import toast from 'react-hot-toast'
import { api } from '../services/api'

/** Abre wa.me en el mismo gesto del clic (sin navegar fuera de Food como fallback). */
function navigateToWhatsapp(url: string) {
  if (typeof window === 'undefined' || !url) return false
  try {
    const a = document.createElement('a')
    a.href = url
    a.target = '_blank'
    a.rel = 'noopener noreferrer'
    a.style.display = 'none'
    document.body.appendChild(a)
    a.click()
    a.remove()
    return true
  } catch {
    const w = window.open(url, '_blank', 'noopener,noreferrer')
    return Boolean(w)
  }
}

async function markFoodLogMissOpened(id: string) {
  try {
    await api.get(`/admin-notifications/${id}/whatsapp`)
  } catch {
    // Si ya abrimos con waUrl prefetch, al menos marcamos leído.
    await api.patch(`/admin-notifications/${id}/read`).catch(() => {})
  }
}

/**
 * Abre WhatsApp del recordatorio sin alimentos.
 * Prefiere waUrl del listado (mismo gesto); siempre intenta marcar leído en API.
 */
export async function openFoodLogMissWhatsapp(id: string, prefetchedUrl?: string | null) {
  const known = String(prefetchedUrl || '').trim()
  if (known.startsWith('https://wa.me/')) {
    const opened = navigateToWhatsapp(known)
    await markFoodLogMissOpened(id)
    if (!opened) toast.error('Permite ventanas emergentes para abrir WhatsApp')
    return opened
  }

  try {
    const { data } = await api.get(`/admin-notifications/${id}/whatsapp`)
    if (!data?.url) {
      toast.error('Este usuario no tiene teléfono para WhatsApp')
      return false
    }
    const opened = navigateToWhatsapp(String(data.url))
    if (!opened) toast.error('Permite ventanas emergentes para abrir WhatsApp')
    return opened
  } catch (e: any) {
    const msg = e?.response?.data?.message || 'Este usuario no tiene teléfono para WhatsApp'
    toast.error(Array.isArray(msg) ? msg[0] : String(msg))
    return false
  }
}
